export const DEFAULT_PASTEL_COLORS = [
    '#EFE4D0',
    '#D0D1EF',
    '#D0EFEA',
    '#EED0EF',
    '#EFD0D1',
    '#D0EFD1',
    '#D0DBEF',
    '#DEE6E9',
    '#FAE7D7',
    '#FDFADE',
    '#E9EFD0',
    '#D0E5EF',
    '#FFFFFF',
    '#BEBEBE',
];

export const DEFAULT_PASTEL_TEXT_COLORS = [
    '#624D27',
    '#3A3A71',
    '#26574F',
    '#5E2F60',
    '#663535',
    '#39603B',
    '#303F5B',
    '#3A3A3A',
    '#5D4939',
    '#58563E',
    '#363B23',
    '#2B414C',
    '#434343',
    '#363636',
];
